// extracted by mini-css-extract-plugin
module.exports = {"userListLink":"updateLocalPassword_userListLink__a8pWG"};